function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  visibility: "visible",
  id: "MasterSlide_1_Default"
}, /*#__PURE__*/React.createElement("desc", null, "Master slide\n  "), /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  stroke: "none",
  x: 0,
  y: 0,
  width: 4400,
  height: 3500
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  visibility: "visible",
  id: "Slide_1_page1"
}, /*#__PURE__*/React.createElement("g", {
  id: "DrawingGroup_1"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(255,255,255)",
  stroke: "none",
  d: "M 2200,3500 L 0,3500 0,0 4400,0 4400,3500 2200,3500 Z"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  stroke: "none",
  x: -1,
  y: 0,
  width: 4403,
  height: 3502
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(237,28,36)",
  stroke: "none",
  d: "M 3107,431 L 2457,423 2654,156 2944,148 3107,431 Z"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  stroke: "none",
  x: 2456,
  y: 148,
  width: 652,
  height: 284
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(0,0,0)",
  stroke: "none",
  d: "M 989,1156 L 862,1031 1187,713 1504,1031 1377,1156 1187,966 989,1156 Z"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  stroke: "none",
  x: 861,
  y: 713,
  width: 645,
  height: 444
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(0,0,0)",
  stroke: "none",
  d: "M 157,1813 L 269,1678 C 339,1736 417,1763 502,1763 559,1763 587,1743 587,1713 L 587,1713 C 587,1686 567,1671 467,1643 312,1608 199,1566 199,1418 L 199,1418 C 199,1283 304,1193 474,1193 594,1193 692,1228 772,1283 L 672,1426 C 609,1376 537,1353 474,1353 424,1353 404,1376 404,1403 L 404,1403 C 404,1438 424,1453 524,1473 687,1511 792,1566 792,1693 L 792,1693 C 792,1841 679,1926 502,1926 369,1933 249,1891 157,1813 Z"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  stroke: "none",
  x: 156,
  y: 1193,
  width: 637,
  height: 735
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(0,0,0)",
  stroke: "none",
  d: "M 854,1206 L 1052,1206 1052,1473 1307,1473 1307,1206 1504,1206 1504,1918 1307,1918 1307,1651 1052,1651 1052,1918 854,1918 854,1206 Z"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  stroke: "none",
  x: 854,
  y: 1205,
  width: 652,
  height: 715
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(0,0,0)",
  stroke: "none",
  d: "M 1567,1566 L 1567,1566 C 1567,1361 1730,1193 1957,1193 2183,1193 2337,1353 2337,1558 L 2337,1558 C 2337,1763 2174,1933 1949,1933 1724,1933 1567,1771 1567,1566 Z M 2132,1566 L 2132,1566 C 2132,1461 2055,1368 1949,1368 1843,1368 1764,1453 1764,1558 L 1764,1558 C 1764,1666 1842,1748 1949,1748 2062,1756 2132,1671 2132,1566 Z"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  stroke: "none",
  x: 1566,
  y: 1193,
  width: 772,
  height: 742
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(0,0,0)",
  stroke: "none",
  d: "M 2704,1206 C 2887,1206 2999,1298 2999,1461 2999,1628 2874,1713 2697,1713 L 2597,1713 2597,1918 2399,1918 2399,1206 2704,1206 Z M 2689,1566 C 2759,1566 2802,1531 2802,1473 2802,1411 2759,1383 2689,1383 L 2597,1383 2597,1573 2689,1573 2689,1566 Z"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  stroke: "none",
  x: 2399,
  y: 1205,
  width: 602,
  height: 715
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(0,0,0)",
  stroke: "none",
  d: "M 1052,1968 L 1052,2511 1399,2511 1399,2688 854,2688 854,1968 1052,1968 Z"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  stroke: "none",
  x: 854,
  y: 1968,
  width: 547,
  height: 722
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(0,0,0)",
  stroke: "none",
  d: "M 1392,2328 L 1392,2328 C 1392,2123 1554,1953 1779,1953 1999,1953 2159,2116 2159,2321 L 2159,2321 C 2159,2526 1998,2696 1772,2696 1545,2696 1392,2533 1392,2328 Z M 1962,2328 L 1962,2328 C 1962,2223 1884,2131 1779,2131 1674,2131 1597,2216 1597,2321 L 1597,2321 C 1597,2426 1674,2511 1779,2511 1884,2518 1962,2426 1962,2328 Z"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  stroke: "none",
  x: 1391,
  y: 1953,
  width: 770,
  height: 744
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(0,0,0)",
  stroke: "none",
  d: "M 2224,2328 L 2224,2328 C 2224,2116 2387,1953 2597,1953 2747,1953 2837,2018 2902,2103 L 2754,2216 C 2712,2166 2669,2131 2597,2131 2499,2131 2429,2216 2429,2321 L 2429,2321 C 2429,2426 2499,2511 2597,2511 2674,2511 2717,2476 2759,2426 L 2909,2533 C 2837,2623 2754,2696 2592,2696 2387,2696 2224,2541 2224,2328 Z"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  stroke: "none",
  x: 2224,
  y: 1953,
  width: 687,
  height: 744
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(0,0,0)",
  stroke: "none",
  d: "M 3192,1961 L 3381,1961 3684,2681 3471,2681 3424,2553 3149,2553 3099,2681 2894,2681 3192,1961 Z M 3359,2398 L 3281,2193 3204,2398 3359,2398 Z"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  stroke: "none",
  x: 2894,
  y: 1960,
  width: 791,
  height: 722
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(0,0,0)",
  stroke: "none",
  d: "M 3931,1968 L 3931,2511 4276,2511 4276,2688 3734,2688 3734,1968 3931,1968 Z"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  stroke: "none",
  x: 3733,
  y: 1968,
  width: 545,
  height: 722
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(255,255,255)",
  stroke: "none",
  d: "M 3626,1043 L 3296,1043 3296,911 3626,911 3626,1043 Z"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  stroke: "none",
  x: 3296,
  y: 910,
  width: 332,
  height: 135
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(0,0,0)",
  stroke: "none",
  d: "M 3669,1086 L 3586,1086 3586,953 3339,953 3339,1086 3254,1086 3254,868 3669,868 3669,1086 Z"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  stroke: "none",
  x: 3253,
  y: 868,
  width: 417,
  height: 219
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(0,0,0)",
  stroke: "none",
  d: "M 3754,1713 L 3754,1128 3169,1128 3169,1713 3754,1713 Z M 3839,1043 L 3839,1798 3084,1798 3084,1043 3839,1043 Z"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  stroke: "none",
  x: 3084,
  y: 1043,
  width: 756,
  height: 757
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(255,255,255)",
  stroke: "none",
  d: "M 2792,1128 L 2414,1128 2414,373 3169,373 3169,1128 2792,1128 Z"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  stroke: "none",
  x: 2414,
  y: 373,
  width: 757,
  height: 757
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(0,0,0)",
  stroke: "none",
  d: "M 3084,1043 L 3084,458 2499,458 2499,1043 3084,1043 Z M 3169,373 L 3169,1128 2414,1128 2414,373 3169,373 Z"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  stroke: "none",
  x: 2414,
  y: 373,
  width: 757,
  height: 757
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(0,0,0)",
  stroke: "none",
  d: "M 3304,3013 C 3351,3013 3389,3056 3381,3096 L 3381,3096 C 3381,3146 3351,3181 3304,3181 3261,3181 3227,3138 3227,3096 L 3227,3096 C 3227,3048 3254,3013 3304,3013 Z"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  stroke: "none",
  x: 3226,
  y: 3013,
  width: 158,
  height: 169
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(0,0,0)",
  stroke: "none",
  d: "M 1052,3118 L 1089,3033 1124,3118 1052,3118 Z"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  stroke: "none",
  x: 1051,
  y: 3033,
  width: 75,
  height: 87
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(0,0,0)",
  stroke: "none",
  d: "M 157,2821 L 4269,2821 4269,3378 157,3378 157,2821 Z M 699,3231 L 699,2971 644,2971 644,3076 537,3076 537,2971 482,2971 482,3231 537,3231 537,3126 644,3126 644,3231 699,3231 Z M 1167,3231 L 1237,3231 1124,2971 1067,2971 954,3231 1009,3231 1032,3176 1144,3176 1167,3231 Z M 1737,3231 L 1752,3231 1752,2971 1687,2971 1617,3083 1547,2971 1484,2971 1484,3231 1539,3231 1539,3061 1609,3176 1682,3061 1682,3231 1737,3231 Z M 2069,3231 L 2069,2971 2012,2971 2012,3231 2069,3231 Z M 2337,3231 L 2527,3231 2527,3181 2394,3181 2394,2971 2337,2971 2337,3231 Z M 2937,3018 L 2944,3018 2944,2963 2724,2963 2724,3018 2802,3018 2802,3231 2859,3231 2859,3018 2937,3018 Z M 3444,3096 C 3444,3017 3389,2963 3304,2963 3219,2963 3162,3018 3162,3096 3162,3168 3227,3231 3304,3231 3389,3231 3444,3174 3444,3096 Z M 3939,3231 L 3939,2971 3881,2971 3881,3133 3761,2971 3706,2971 3706,3231 3761,3231 3761,3061 3889,3231 3939,3231 Z"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  stroke: "none",
  x: 156,
  y: 2820,
  width: 4114,
  height: 560
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(0,0,0)",
  stroke: "none",
  d: "M 3107,431 L 2902,191 2682,191 2477,431 2414,373 2639,106 2944,106 3169,373 3107,431 Z"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  stroke: "none",
  x: 2414,
  y: 105,
  width: 757,
  height: 327
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(0,0,0)",
  stroke: "none",
  d: "M 2944,1128 L 2639,1128 2639,733 2944,733 2944,1128 Z M 2724,1043 L 2859,1043 2859,818 2724,818 2724,1043 Z"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  stroke: "none",
  x: 2639,
  y: 733,
  width: 307,
  height: 397
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(67,198,242)",
  stroke: "none",
  d: "M 3459,1713 L 3162,1713 3162,1113 3754,1113 3754,1713 3459,1713 Z"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  stroke: "none",
  x: 3161,
  y: 1113,
  width: 594,
  height: 602
}))));

function SvgShoplocalhamilton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    width: "44mm",
    height: "35mm",
    viewBox: "0 0 4400 3500",
    preserveAspectRatio: "xMidYMid",
    fillRule: "evenodd",
    strokeWidth: 28.222,
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoplocalhamilton);
export default __webpack_public_path__ + "static/media/shoplocalhamilton.49851a44.svg";
export { ForwardRef as ReactComponent };